import { type FC } from "react";
import { FormItemName } from "@root/shared/components/FormItemName";
import { InformationText } from "@root/shared/components/InformationText";
import { SelectBox } from "@root/shared/components/SelectBox";
import { StepCassette } from "../StepCassette";
import * as styles from "./styles.css";
import { headingEmphasis } from "../../styles.css";

type Props = {
  jobTypeName: string;
  experienceValue: string;
  options: { label: string; value: string }[];
  errorMessage?: string;
  error: string | null;
  isLoading: boolean;
  onChangeExperience: (value: string) => void;
};

export const Presentation: FC<Props> = ({
  jobTypeName,
  experienceValue,
  options,
  errorMessage,
  error,
  isLoading,
  onChangeExperience,
}) => (
  <StepCassette
    jobTypeAndExperience={jobTypeName}
    heading={
      <>
        <span className={headingEmphasis}>経験</span>を教えてください
      </>
    }
  >
    <FormItemName labelRequirementType="required">職種の経験</FormItemName>
    <span className={styles.selectBoxWrapper}>
      <SelectBox
        name="jobExperience"
        aria-label="職種の経験を選択"
        value={experienceValue}
        selected={!!experienceValue}
        options={options}
        placeholder="選択してください"
        hasError={!!errorMessage || !!error}
        disabled={isLoading}
        onChange={(e) => onChangeExperience(e.target.value)}
      />
    </span>
    {(errorMessage ?? error) && (
      <InformationText isAlert text={errorMessage ?? error} className={styles.errorMessage} />
    )}
  </StepCassette>
);
